import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const alertSlice = createSlice({
  name: "alert",
  initialState: [],
  reducers: {
    setAlert: (state, action) => {
      state.push({
        id: action.payload.id,
        message: action.payload.message,
        type: action.payload.type,
      });
    },
    removeAlert: (state, action) => {
      const alertIndex = state.findIndex(
        (alertItem) => alertItem.id === action.payload
      );
      if (alertIndex !== -1) {
        state.splice(alertIndex, 1);
      }
    },
  },
});

export const { setAlert, removeAlert } = alertSlice.actions;

export const setSuccessAlert = createAsyncThunk(
  "alert/setSuccessAlert",
  async (message, ThunkApi) => {
    const id = +new Date();

    // set alert
    ThunkApi.dispatch(
      setAlert({
        id,
        type: "success",
        message: message,
      })
    );

    setTimeout(() => {
      ThunkApi.dispatch(removeAlert(id));
    });
  }
);

export const setErrorAlert = createAsyncThunk(
  "alert/setErrorAlert",
  async (message, ThunkApi) => {
    const id = +new Date();

    // set alert
    ThunkApi.dispatch(
      setAlert({
        id,
        type: "error",
        message: message,
      })
    );

    ThunkApi.dispatch(removeAlert(id));
  }
);

export const setValidationAlert = createAsyncThunk(
  "alert/setValidationAlert",
  async (message, ThunkApi) => {
    const id = +new Date();

    // set alert
    ThunkApi.dispatch(
      setAlert({
        id,
        type: "validationFailed",
        message: message,
      })
    );

    ThunkApi.dispatch(removeAlert(id));
  }
);

export default alertSlice.reducer;
